import React, { useState } from "react";
import { Pagination } from "@patternfly/react-core";

export default (props) => {
  const [page, setPage] = useState(props.page);
  const [perPage, setPerPage] = useState(props.perPage);

  function onSetPage(event, pageNumber) {
    setPage(pageNumber);
    props.setPageContent(
      props.allPageContent.slice(
        (pageNumber - 1) * perPage,
        (pageNumber - 1) * perPage + perPage
      )
    );
  }

  function onPerPageSelect(event, perPage) {
    setPerPage(perPage);
    props.setPageContent(props.allPageContent.slice(0, perPage));
  }

  return (
    <Pagination
      itemCount={props.itemCount}
      perPage={perPage}
      page={page}
      onSetPage={onSetPage}
      widgetId={`pagination-${props.id}`}
      onPerPageSelect={onPerPageSelect}
    />
  );
};
